import {
  queryOptions,
  type QueryKeyWithDataTag,
  type UnusedSkipTokenOptions,
} from "@tanstack/react-query";

type Key = readonly string[];

/** A workspace read, shared by its `use…` hook and the route loader that prefetches it. */
export type WorkspaceQuery<T> = UnusedSkipTokenOptions<T, Error, T, Key> &
  QueryKeyWithDataTag<Key, T, Error>;

export const workspaceQuery = <T>(queryKey: Key, queryFn: () => Promise<T>): WorkspaceQuery<T> =>
  queryOptions({ queryKey, queryFn });
